import React from "react";
import { ComingSoon } from "./atoms.jsx";
import { I } from "./icons.jsx";
import "./alerts.css";

const ACCOUNT_TOOLS_DETAIL =
  "Alert rules, notification channels, alert history, and saved searches are gated until accounts ship.";

const RightSummary = () => (
  <div className="right-summary" aria-label="Alerts summary">
    <div className="right-stat">
      <div className="rs-v">Soon</div>
      <div className="rs-k">Active rules</div>
    </div>
    <div className="right-stat">
      <div className="rs-v">Soon</div>
      <div className="rs-k">Delivery history</div>
    </div>
  </div>
);

const AlertsDrawer = ({ onComingSoon, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  const panelId = "alerts-drawer-panel";

  React.useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  const openAccountTools = () => onComingSoon?.("Account tools", ACCOUNT_TOOLS_DETAIL);

  return (
    <aside className={`alerts-shell ${open ? "open" : "collapsed"}`} data-testid="alerts-drawer" aria-label="Alerts drawer">
      <button
        className="alerts-dock"
        data-testid="alerts-drawer-toggle"
        type="button"
        aria-expanded={open}
        aria-controls={panelId}
        aria-label={open ? "Collapse alerts drawer" : "Expand alerts drawer"}
        title={open ? "Collapse alerts" : "Expand alerts"}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="alerts-dock-btn" aria-hidden="true">
          <I.bell size={15}/>
          <span className="alerts-dock-count">soon</span>
        </span>
        <span className="alerts-dock-label" aria-hidden="true">Alerts</span>
      </button>

      {open ? (
        <section className="right-rail" id={panelId} aria-label="Alerts panel">
          <div className="right-head">
            <div>
              <h2>Alerts</h2>
              <div className="rh-sub">Rules, channels, and delivery history stay tucked away until you need them.</div>
            </div>
            <button className="btn icon sm ghost" type="button" onClick={() => setOpen(false)} aria-label="Collapse alerts drawer" title="Collapse alerts">
              <I.chevR size={14}/>
            </button>
          </div>
          <RightSummary/>
          <div className="right-body">
            <ComingSoon
              variant="panel"
              feature="Account tools"
              detail={ACCOUNT_TOOLS_DETAIL}
              onAction={openAccountTools}
              actionLabel="Coming soon"
            />
          </div>
        </section>
      ) : null}
    </aside>
  );
};

export { AlertsDrawer, AlertsDrawer as RightRail };
